import React from 'react';
import styles from '../Operations.module.css';


interface INSTComponent extends React.FC {
  title?: string;
  kpiHyperlink?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

/**
 * INST - Ace In-Stock (rolling 12 average)
 * KPI information component
 */
const INST: INSTComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>

      <div className={styles.sectionContent}>
        The percent of active SKUs that are in-stock on a weekly basis.
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>

      <div className={styles.sectionContent}>
        The report is populated based on the previous week&apos;s data and available each Monday.
        Ace calculates the popularity code for each SKU based on Ace&apos;s best practice standards.
        The monthly in-stock percentage is weighted by popularity, putting more emphasis on the faster selling items and less on the slower selling items.
      </div>

      <div className={styles.sectionContent}>
        The weighting is as follows:<br/><br/>
        <table style={{ borderCollapse: 'collapse', border: '1px solid black' }}>
          <thead>
            <tr>
              <th style={{ padding: '5px', border: '1px solid black' }}>Previous 12 Month Units Sold Range</th>
              <th style={{ padding: '5px', border: '1px solid black' }}>Popularity Code</th>
              <th style={{ padding: '5px', border: '1px solid black' }}>Weighted Impact</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ padding: '5px', border: '1px solid black' }}>76 or more</td>
              <td style={{ padding: '5px', border: '1px solid black' }}>A</td>
              <td style={{ padding: '5px', border: '1px solid black' }}>40%</td>
            </tr>
            <tr>
              <td style={{ padding: '5px', border: '1px solid black' }}>26 to 75</td>
              <td style={{ padding: '5px', border: '1px solid black' }}>B</td>
              <td style={{ padding: '5px', border: '1px solid black' }}>30%</td>
            </tr>
            <tr>
              <td style={{ padding: '5px', border: '1px solid black' }}>9 to 25</td>
              <td style={{ padding: '5px', border: '1px solid black' }}>C</td>
              <td style={{ padding: '5px', border: '1px solid black' }}>20%</td>
            </tr>
            <tr>
              <td style={{ padding: '5px', border: '1px solid black' }}>1 - 8</td>
              <td style={{ padding: '5px', border: '1px solid black' }}>D</td>
              <td style={{ padding: '5px', border: '1px solid black' }}>10%</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className={styles.sectionContent}>
        Ace calculates the in-stock percentage for each SKU each week using the following equation:<br/>
        <strong>In-Stock %</strong> = (7 - # of days out of stock)/7<br/><br/>
        For example, if you were out of stock 3 days last week, your In-Stock percentage would be represented as:<br/><br/>
        57.1 % = (7 – 3) / 7<br/><br/>
        At the end of each month, the weekly reports are summarized to display the monthly weighted in-stock percentage on the Retail Analytics Dashboard.
      </div>

      <div className={styles.sectionContent}>
        Items with the following criteria are included in the report and weighted percentage:<br/>
        • Active Ace and Non-Ace SKUs that have sold at least one unit in the last 12 months<br/>
        • Active RSC Outs that have sold at least one unit in the last 12 months
      </div>

      <div className={styles.sectionContent}>
        Items with the following criteria are excluded from the report and weighted percentage:<br/>
        • Store Closeouts/ Discontinued<br/>
        • Seasonal SKUs are excluded when out of season (defined by merchandising class)<br/>
        • Temporary closeouts (through ICM)<br/>
        • Order Indicator = S (Special Orders)<br/>
        • SKUs without stocking information<br/>
        • Items with zero sales in the last 12 months
      </div>

      <div className={styles.sectionTitle}>
        Goal
      </div>

      <div className={styles.sectionContent}>
        Platinum - 93 - 94.9%<br/>
        Pinnacle - 95% and above
      </div>

      <div className={styles.sectionTitle}>
        Drill Down
      </div>

      <div className={styles.sectionContent}>
        Clicking the In-Stock Link will display In-Stock details (Summary, Monthly, Sku)
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>

      <div className={styles.sectionContent}>
        See Ace Way of Retailing (AWOR){' '}
        <a
          href="https://acenet.aceservices.com/awor/inventory-management/in-stock-position/in-stock-position-summary"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}>
          In-Stock Position
        </a>
        {' '}document for instructions on managing your In-Stock Position.
      </div>
    </div>
  );
};


INST.title = 'Ace In-Stock Percentage';
INST.kpiHyperlink = 'dynamicURL:ACENET:description';
INST.actionTitle = 'Review Out Of Stock Skus';
INST.actionHyperlink = 'dynamicURL:WFC:current';
export default INST;


